<ng-container *appTranslate="let t" class="h-full">
  <new-ui-dashboard-card>
    <ng-template #header>
      <new-ui-dashboard-card-header [title]="t('dashboard.milestone.title', { candidateSum: candidateSum ?? 0 })">
      </new-ui-dashboard-card-header>
    </ng-template>

    @if (candidateSum === null) {
      <ui-emptystate
        class="py-1"
        image="/assets/layout/images/new-ui/book2.png"
        [caption]="t('dashboard.milestone.emptyState.title')"
        [description]="t('dashboard.milestone.emptyState.description')"
      />
    } @else {
      <new-ui-milestone-aggregated-view
        [readonly]="true"
        (candidateSum)="onCandidateSumChange($event)"
        (rowCount)="onRowCountChange($event)"
      />
    }
  </new-ui-dashboard-card>
</ng-container>
